<template>
  <div style="min-height: 92vh">
    <div>
      <h3>Usuarios de la agencia</h3>
      <uv-data-table
        :config="config"
        :data="data_usurios"
        :pageRows="15"
        @buttonClick="dtButtonClick"
        @buttonOptClick="optButtonClick"
      ></uv-data-table>
    </div>
    <modal v-model="showModal" :showFooter="false" title="Agregar Usuario">
      <addform
        :key="formKey"
        @toggle="toggleModal"
        @successData="successData"
        :hoteles="hoteles"
      ></addform>
    </modal>
  </div>
</template>

<style></style>

<script>
import modal from "../../MainComponents/modal.vue";
import addform from "./UsuarioAfiliadoForm.vue";
import uvDataTable from "../../MainComponents/uvDataTable.vue";

let fSingleton;
export default {
  name: "UsuarioAfiliado",
  components: {
    modal,
    addform,
    uvDataTable,
  },
  props: [],
  data() {
    return {
      self: this,
      showModal: false,
      formKey: 0,
      hoteles: [],
      usuarios: [],
      config: {
        selectableRow: true,
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [
          {
            text: "Agregar Usuario",
            icon: "lni lni-plus",
            buttonId: "addUser",
          },
          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "deleteUser",
            require: true,
          },
        ],
        fields: [
          {
            title: "Codigo de Agencia",
            dataName: "codigoHotel",
          },
          {
            title: "Usuario",
            dataName: "usuario",
          },
          {
            title: "Login User",
            dataName: "login",
          },
          {
            title: "Agencia",
            dataName: "hotel",
          },
        ],
      },
    };
  },
  methods: {
    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "addUser") {
        this.toggleModal(true);
      }
      if (buttonId == "deleteUser") {
        this.deleteUser(idSelected[0]);
      }
    },
    optButtonClick(buttonId, ref) {
      if (buttonId == "delete") {
        this.deleteUser(ref);
      }
    },
    async getHoteles() {
      //obtiene el listado de hoteles afiliados
      const data = this.$store.getters.getFirebaseApp.database.ref(
        "RVA/Mayoristas/Coleccion"
      );
      this.$store.getters.getFirebaseApp.database.onValue(data, (snapshot) => {
        this.hoteles = [];
        let arrayHoteles = Object.entries(snapshot.val());
        arrayHoteles.forEach((element) => {
          this.hoteles.push({ id: element[0], ...element[1] });
        });
      });
    },

    successData(data, data_hotel) {
      let dataUser = {
        hotelId: this.getHotelinfo(
          this.$route.params.user.tokenResult.claims.Code
        ).id,
        hotelCode: this.$route.params.user.tokenResult.claims.Code,
        username: data.username,
        password: data.password,
        name: data.nombre,
        URLAdmin: data_hotel.URLAdmin,
      };
      this.$pgsHelper.log(dataUser);
      this.saveUsuario(dataUser);
    },
    saveUsuario(data) {
      this.$swal({
        title: "¿Deseas guardar el usuario  de la agencia?",
        text: "El usuario se guardara con los datos especificados",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("RVA-Mayoristas-crearUserMayorista", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "Usuario Guardado",
              "El usuario se almaceno correctamente",
              "success"
            );
            this.getUsers();
            this.showModal = false;
            this.formKey++;
          } else {
            this.$swal("Error saving data", "Your data didnt save", "error");
          }
        }
      });
    },
    toggleModal(open) {
      this.formKey++;
      this.showModal = open;
    },
    async getUsers() {
      let hCode = this.$route.params.user.tokenResult.claims.Code;
      const database = this.$store.getters.getFirebaseApp.database;
      let user = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "RVA/Mayoristas/Usuarios",
        [
          database.orderByChild("ADMN~~MCDE"),
          database.equalTo("FALSE~~" + hCode),
        ]
      );
      let new_users = [];
      if (user.exists()) {
        let us = {};
        let result = Object.entries(user.val());
        result.forEach((usu) => {
          /*us  =   Object.entries(element[1]);
                new_users.push({id:us[0][0],...us[1]});*/
          //let users = Object.entries(element[1])
          /*users.forEach((usu)=>{*/
          let userData = { id: usu[0], ...usu[1] };

          new_users.push(userData);
          /*})*/
        });
        //result[1]  =   Object.entries(result[1]);

        this.usuarios = new_users;
      } else {
        alert("No existen usuarios");
      }
    },
    getHotelinfo(code) {
      let itemIndex = this.$_.findIndex(this.hoteles, { Codigo: code });
      if (itemIndex >= 0) {
        return this.hoteles[itemIndex];
      }

      return false;
    },
    getUserName(fullUser) {
      let dash = fullUser.split("_");
      let at = dash[1].split("@");
      return at[0];
    },
    async deleteUser(id) {
      this.$swal({
        title: "¿Deseas eliminar este Usuario?",
        text: "Se eliminara permanentemente",
        icon: "warning",
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          let data = { uid: id };
          return await this.$store.getters.getFirebaseApp.fba
            .call("RVA-Mayoristas-eliminarUsuarioMayorista", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "Usuario elimando",
              "El usuario se elimino correctamente",
              "success"
            );
            this.$emit("changeIndex");
          } else {
            this.$swal("Error deleting data", "Your data didnt save", "error");
          }
        }
      });
    },
  },
  computed: {
    tipoUsuario() {
      return this.$route.params.user.tokenResult.claims.Type;
    },
    data_usurios() {
      let data = [];
      this.usuarios.forEach((element) => {
        let user = {
          codigoHotel: element.MCode,
          usuario: element.Correo,
          id: element.id,
          login: this.getUserName(element.Correo.toString()),
          hotel: this.getHotelinfo(element.MCode)
            ? this.getHotelinfo(element.MCode).Nombre
            : "La agencia no existe",
        };
        data.push(user);
      });

      return data;
    },
  },
  watch: {},
  mounted() {
    this.$pgsHelper.log(
      this.$route.params.user.tokenResult.claims.Data.EsAdmin
    );
  },
  async created() {
    await this.getHoteles();
    await this.getUsers();
  },
};
</script>
